<template>
  <div class="row">
    <div class="col col-md-12">
      <Dialog :id="'dialogExport'" ref="dialogExport" :hide-header="false" :noClassFooter="true"
        :modal="view == 'modal'"  titulo="Exportar" classModalBody="text-center">
        
        <div><p class="fs-5 p-3">A exportação será limitada em 5000 itens<br />utilize o filtro de datas para limitar a quantidade de resultados</p></div>


        <div class="row justify-content-center mt-3 mb-2">
          <div class="col-6">
            <label class="fs-6 fw-bold mb-2">Selecione o formato de saída</label>
            <Combo v-model="item.formato"
              :itens="[{ 'id': 'excel', 'nome': 'Excel' },{ 'id': 'csv', 'nome': 'CSV' }]" autofocus="true"
              :classSelect2="false" />
          </div>
        </div>


        <template #rodape>
          <div class="row pt-2 pb-2" style="border-top: 1px solid #eff2f5">
            <div class="col-md-12 col-sm-12 d-flex justify-content-center"
              style="align-items: center; padding: 0.75rem">
              <button type="button" class="btn btn-secondary me-1" @click="fechar()">
                Cancelar
              </button>
              <button type="button" class="btn btn-warning" @click="exportar()">
                Exportar
              </button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";
import { useAuthStore } from "@/stores/auth.js";
import { useStoreArvore } from "../stores/storeArvore.js";

import Dialog from "../components/ComponentDialog.vue";
import Combo from "../components/ComponentCombo.vue";

export default {
  components: { Combo, Dialog },
  props: {
    view: { type: String, default: "modal" }
  },

  computed: {
  },

  data() {
    return {
      authStore: null,
      item: {formato: "excel"}
    };
  },

  mounted() {
    this.authStore = useAuthStore();
  },

  methods: {
    abrir() {
      this.item.formato = "excel";
      this.$emit("dialog-on");
      this.$refs.dialogExport.abrir();
    },
    fechar() {
      this.$refs.dialogExport.fechar();
      this.$emit("dialog-off");
    },
    exportar() {
      this.$emit("exportar", {formato: this.item.formato});
      this.$refs.dialogExport.fechar();
      this.$emit("dialog-off");
    },
  },
};
</script>

<style></style>
